import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './footer.css'
import Kaffa from './images/perkleaflogo.png'
import icon1 from './images/twitter-brands.svg'
import icon2 from './images/facebook-f-brands.svg'
import icon3 from './images/instagram-brands.svg'
import icon4 from './images/youtube-brands.svg'
import location from './images/location-dot-solid.svg'
import phone from './images/phone-solid.svg'

function Footer() {
  return (
    <Container fluid id='footerContainer'>
      <Row>
        <Col md={4} xs={12}>
          <Row>
            <Col id='footlogo'>
              <img id='footlogoimg' src={Kaffa} alt="Kaffa logo" />
            </Col>
          </Row>
          <Row>
            <Col style={{ margin: "0 10%" }}><p style={{fontSize:"15px"}}>Good coffee. Good vibes. <br></br>
              From bold espressos to frothy lattes, we’ve got your cravings covered.
              Hang out, catch up, or simply chill — your cup is waiting.</p></Col>
          </Row>
          <Row>
            <Col id='footsocialcol' style={{ margin: "5%" }}>

              <img src={icon1} id='contIcon' />
              <img src={icon2} id='contIcon' />
              <img src={icon3} id='contIcon' />
              <img src={icon4} id='contIcon' />
            </Col>
          </Row>
        </Col>
        <Col id='col2' md={4} xs={12}>
          <Row>
            <h3>Contact Info</h3>
            <div id="line"></div>
          </Row>
          <Row><div id='conaddress'>
            <div id='locicon'>
              <img src={location} />
            </div>
            <div>
              <h5>Our location</h5>
              <p>Perkleaf Cafe, Medical Chowk , Near LOC Cafe , Nagpur- 440009</p>
            </div>
          </div></Row>
          <Row>
            <div id='locate'>
              <div id='phoneicon'>
                <img src={phone} />
              </div>
              <div>
                <h5>Phones: </h5>
                <h6>9284661825</h6>
                <h6>perkleafcoffee@gmail.com</h6>
              </div>

            </div>
          </Row>
        </Col>
        <Col id='col3' md={4} xs={0} >
          <Row>
            <h3>Subscribe</h3>
            <div id="line1"></div>
          </Row>
          <Row>
            <div id='input'>
              <input id="place" type="email" placeholder='Your email...' alt="" />
              <button>Subscribe</button>
            </div>
            {/* <div>
              <input id="checkk" type="checkbox"></input>
              <span> I have read and agree to the terms & conditions</span>
            </div> */}
          </Row>


        </Col>

      </Row>
      {/* <div id="line2">1</div> */}

      <Row>
        <Col id="footlast" >
        <span id="cright" >© 2025. All Rights Reserved. Design by AMPLEMIND</span>
        </Col>
      </Row>
    </Container>
  )
}

export default Footer